import React from 'react';

const ErrorCrossIcon = (props) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={20} height={20} rx={10} fill="#B74242" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2324 6.76765C13.5448 7.08007 13.5448 7.5866 13.2324 7.89902L7.89904 13.2324C7.58662 13.5448 7.08009 13.5448 6.76767 13.2324C6.45525 12.9199 6.45525 12.4134 6.76767 12.101L12.101 6.76765C12.4134 6.45523 12.92 6.45523 13.2324 6.76765Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.76767 6.76765C7.08009 6.45523 7.58662 6.45523 7.89904 6.76765L13.2324 12.101C13.5448 12.4134 13.5448 12.9199 13.2324 13.2324C12.92 13.5448 12.4134 13.5448 12.101 13.2324L6.76767 7.89902C6.45525 7.5866 6.45525 7.08007 6.76767 6.76765Z"
      fill="white"
    />
  </svg>
);
export default ErrorCrossIcon;
